import React from 'react';
import TitleHelmet from 'components/TitleHelmet';

const Terms: React.FC = () => {
  return (
    <div className="terms">
      <TitleHelmet title="Terms of Service" />
      <h1>Terms of Service</h1>
      <p>
        <em>Effective date: March 18, 2024</em>
      </p>

      <p>
        Welcome to fatscientist.com ("Site"), operated by Productist LLC ("we," "us," or "our"). By accessing or using
        this Site, you agree to be bound by these terms.
      </p>

      <h2>Use of the Site</h2>
      <p>
        The content and calculator on this Site are provided solely for informational and educational purposes. We do
        NOT provide medical advice, diagnosis, or treatment. Using the calculator does not establish any form of
        doctor-patient relationship.
      </p>
      <p>
        You may use this Site for personal, non-commercial purposes only. You agree not to copy, distribute, modify, or
        create derivative works based on any content from the Site without prior written permission from Productist LLC.
        Unauthorized use may result in termination of your access to the Site.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Productist LLC provides this website and its tools for informational purposes only. We do not guarantee
        accuracy, completeness, or applicability. By using this Site, you agree that Productist LLC is not liable for
        any damages, injuries, or adverse effects resulting from reliance on the provided information.
      </p>
      <p>
        To the fullest extent permitted by law, Productist LLC shall NOT be liable for any damages (including personal
        injury or death) arising from your use of the calculator or any content on this Site, regardless of the cause,
        including negligence or miscalculation. You assume all risks associated with your use of this Site and any
        calculations or information derived from it.
      </p>

      <h2>Accuracy of Information</h2>
      <p>
        We strive for accuracy, but we make NO guarantee of correctness, completeness, or suitability of any information
        or calculation. Always confirm dosage information with your healthcare provider. The content may be subject to
        errors, and we reserve the right to make corrections at any time without prior notice.
      </p>

      <h2>Third-Party Links</h2>
      <p>
        Our Site may contain links to third-party websites or services that are not owned or controlled by Productist
        LLC. We are not responsible for the content, privacy policies, or practices of any third-party sites. Accessing
        these links is at your own risk.
      </p>

      <h2>Jurisdiction</h2>
      <p>
        This Site is operated from Oregon, USA. You agree that any legal action related to this Site shall be governed
        by Oregon law, with exclusive jurisdiction in Oregon state courts.
      </p>

      <h2>International Users</h2>
      <p>
        This Site is intended for users in the United States. Users accessing this Site from outside the U.S. do so at
        their own risk and are responsible for complying with their local laws.
      </p>

      <h2>Donations</h2>
      <p>
        Donations to FatScientist.com are voluntary and support site maintenance. Contributions do not establish a
        business or client relationship with Productist LLC.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We reserve the right to modify these terms at any time. By continuing to use the Site after any changes are
        posted, you accept and agree to the revised terms.
      </p>

      <h2>Contact</h2>
      <p>For general inquiries about these terms, please contact:</p>
      <p>
        Productist LLC
        <br />
        <a href="mailto:productist@fastmail.com">productist@fastmail.com</a>
      </p>

      <h2>DMCA and Legal Requests</h2>
      <p>
        All legal matters, including DMCA takedown requests and dispute resolution, should be directed to Productist LLC
        at the contact information above. Please include "Legal Request" in your subject line for expedited handling.
      </p>
    </div>
  );
};

export default Terms;
